import { css, styled } from "../../../../../../styles";

export const Container = styled("div", {
  display: "flex",
  flexDirection: "column",
  height: "auto",
  maxHeight: "calc(100vh - 100px)",
  width: "1200px",
  gap: "12px",
  overflowY: "auto",

  "@media screen and (max-width: 1300px)": {
    width: "calc(100vw - 80px)",
    overflow: "scroll",
    height: "calc(100vh - 80px)",
  },
});

export const NotAvailableContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  width: "440px",
  gap: "12px",

  "@media screen and (max-width: 1100px)": {
    width: "calc(100vw - 80px)",
  },
});

export const NotAvailableMessage = styled("p", {
  fontSize: "$text-md",
  lineHeight: "20px",
  padding: "0 22px",
  color: "$gray-100",
});

export const Title = styled("h1", {
  fontWeight: 500,
  fontSize: "$text-xl",
  lineHeight: "22px",
  padding: "24px 22px 12px 22px",
  color: "$black",
});

export const SubmitContainer = styled("div", {
  display: "flex",
  gap: "40px",
  padding: "24px 22px 24px 22px",
  alignItems: "center",
});

export const EditButton = styled("button", {
  height: "$13",
  padding: "0 $13",
  marginLeft: "-38px",

  borderRadius: "20px",
  border: "2px solid $white",

  backgroundColor: "$white",

  gap: "$4",

  display: "flex",
  alignItems: "center",

  color: "$black",
  fontWeight: 600,
  lineHeight: "22px",
  fontSize: "$text-lg",
  fontFamily: "$openSans",

  cursor: "pointer",

  "&:focus": {
    outline: "none",
    border: "2px solid $primary-30",
  },

  "@sm": {
    width: "80px",
    height: "26px",
    fontSize: "12px",
    marginLeft: "40px",
    paddingLeft: "19px",
  },
});

export const Label = styled("p", {
  fontSize: "$text-md",
  paddingBottom: "0px",
  lineHeight: "16px",
  paddingLeft: 22,
  color: "$gray-100",
});

export const AssignedToLabel = styled("p", {
  fontSize: "$text-md",
  paddingBottom: "0px",
  lineHeight: "16px",
  paddingLeft: 22,
  color: "$gray-100",
});

export const UrgentChipContainer = styled("div", {
  paddingLeft: 22,
  display: "flex",
});

export const TextAreaContainer = styled("div", {
  paddingLeft: "22px",
  paddingRight: "22px",
  width: "100%",
  height: "auto",

  // Override Quill's internal scroll to prevent nested scrolling
  // Allow the editor to expand to fit content and let the modal handle scrolling
  "& > div": {
    height: "auto !important",
  },

  "& > div > div": {
    height: "auto !important",
  },

  "& > div > div > div": {
    height: "auto !important",
  },

  ".ql-editor": {
    overflowY: "visible !important",
    height: "auto !important",
    maxHeight: "none !important",
  },

  ".ql-container": {
    height: "auto !important",
  },
});

export const LoadingContainer = styled("div", {
  width: "100%",
  height: "300px",

  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export const spinCss = css({
  ".ant-spin-dot": {
    ".ant-spin-dot-item": {
      backgroundColor: "var(--colors-portal-loading-state-color)",
    },
  },
});

export const GenerateAiButtonContainer = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  paddingLeft: "22px",
  paddingRight: "22px",
  paddingTop: "12px",
  paddingBottom: "12px",
});

export const GenerateAiButton = styled("button", {
  height: "$13",
  padding: "0 $16",
  borderRadius: "6px",
  border: "1px solid $primary",
  backgroundColor: "$white",
  color: "$primary",
  fontWeight: 600,
  fontSize: "$text-md",
  fontFamily: "$openSans",
  cursor: "pointer",
  transition: "all 0.2s ease",
  display: "flex",
  alignItems: "center",
  gap: "$2",

  "&:hover": {
    backgroundColor: "$primary",
    color: "$white",
  },

  "&:focus": {
    outline: "none",
    boxShadow: "0 0 0 3px rgba(124, 77, 255, 0.2)",
  },

  "&:disabled": {
    opacity: 0.6,
    cursor: "not-allowed",
  },
});

export const LoadingMessage = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "$4",
  color: "$gray-100",
  fontSize: "$text-md",
  fontFamily: "$openSans",
});

export const AiSummarySection = styled("div", {
  paddingLeft: "22px",
  paddingRight: "22px",
  paddingBottom: "16px",
  width: "100%",
});

export const AiSummaryCard = styled("div", {
  backgroundColor: "$gray-20",
  borderRadius: "8px",
  padding: "20px",
  border: "1px solid $gray-40",
});

export const AiSummaryHeader = styled("div", {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginBottom: "16px",
  paddingBottom: "12px",
  borderBottom: "1px solid $gray-40",
});

export const AiSummaryTitle = styled("h3", {
  fontSize: "$text-lg",
  fontWeight: 600,
  color: "$black",
  margin: 0,
});

export const AiBadge = styled("span", {
  backgroundColor: "$primary-10",
  color: "$primary-100",
  padding: "4px 8px",
  borderRadius: "4px",
  fontSize: "$text-sm",
  fontWeight: 500,
});

export const AiSummaryContent = styled("div", {
  fontSize: "$text-md",
  lineHeight: "22px",
  color: "$gray-100",

  // Markdown styling
  "& h1, & h2, & h3, & h4": {
    fontSize: "1.1em",
    fontWeight: 600,
    marginTop: "1em",
    marginBottom: "0.5em",
    color: "$black",
    "&:first-child": {
      marginTop: 0,
    },
  },
  "& ul, & ol": {
    paddingLeft: "20px",
    margin: "0.5em 0",
  },
  "& li": {
    marginBottom: "0.25em",
  },
  "& p": {
    margin: "0.5em 0",
    "&:first-child": {
      marginTop: 0,
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  "& strong, & b": {
    fontWeight: 600,
  },
  "& code": {
    fontFamily: "monospace",
    backgroundColor: "rgba(0,0,0,0.05)",
    padding: "0.2em 0.4em",
    borderRadius: "3px",
  },
  "& pre": {
    backgroundColor: "rgba(0,0,0,0.05)",
    padding: "10px",
    borderRadius: "4px",
    overflowX: "auto",
  },
  "& blockquote": {
    borderLeft: "3px solid $gray-40",
    paddingLeft: "12px",
    margin: "0.5em 0",
    color: "$gray-80",
  },
});

export const AiSection = styled("div", {
  marginBottom: "16px",

  "&:last-child": {
    marginBottom: 0,
  },
});

export const AiSectionTitle = styled("h4", {
  fontSize: "$text-md",
  fontWeight: 600,
  color: "$black",
  marginBottom: "8px",
  marginTop: 0,
});

export const AiSectionText = styled("p", {
  fontSize: "$text-md",
  lineHeight: "22px",
  color: "$gray-100",
  margin: 0,
  marginBottom: "8px",
});

export const AiList = styled("ul", {
  margin: 0,
  paddingLeft: "20px",
  fontSize: "$text-md",
  lineHeight: "22px",
  color: "$gray-100",

  li: {
    marginBottom: "4px",
  },
});
